import React from 'react';
import './Services.css';

import service1Image from '../assets/images/services/servico_1.webp';
import service2Image from '../assets/images/services/servico_2.webp';
import service3Image from '../assets/images/services/servico_3.webp';

function Services() {
    const services = [
        {
            id: 1,
            icon: '🖨️',
            title: 'IMPRESSÕES EM 3D FDM',
            description: 'Produção de peças funcionais, utilitários e decorativas em 3D, com acabamento de qualidade e precisão.',
            image: service1Image
        },
        {
            id: 2,
            title: 'PERSONALIZADOS E ENCOMENDAS',
            description: 'Desenvolvimento de projetos sob medida, criando o arquivo 3D a partir de ideias e necessidades específicas.',
            image: service2Image
        },
        {
            id: 3,
            icon: '🎁',
            title: 'CORPORATIVOS E BRINDES',
            description: 'Soluções em impressão 3D para empresas, incluindo brindes personalizados, protótipos e materiais exclusivos para cada empresa.',
            image: service3Image
        }
    ];

    return (
        <section className="services-section" id="servicos">
            <h2>SERVIÇOS</h2>
            <div className="services-container">
                {services.map((service) => (
                    <div key={service.id} className="service-card">
                        {service.image && (
                            <div className="service-image">
                                <img src={service.image} alt={service.title} />
                            </div>
                        )}
                    
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Services;
